import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=8139579e&scoped=true&"
import script from "./IconArrowRight.vue?vue&type=script&lang=js&"
export * from "./IconArrowRight.vue?vue&type=script&lang=js&"
import style0 from "./IconArrowRight.vue?vue&type=style&index=0&id=8139579e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8139579e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8139579e')) {
      api.createRecord('8139579e', component.options)
    } else {
      api.reload('8139579e', component.options)
    }
    module.hot.accept("./IconArrowRight.vue?vue&type=template&id=8139579e&scoped=true&", function () {
      api.rerender('8139579e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconArrowRight.vue"
export default component.exports